import { Asterisk, CircleAlert } from "lucide-react";
import "./AppCustomPropertyError.css";
import { MyTooltip } from "../../common/MyTooltip";

type AppCustomPropertyErrorProps = {
    flagRequired: boolean;
    flagError?: boolean;
    errorString?: string;
}

export const AppCustomPropertyError = ({flagRequired, flagError = false, errorString = ""}: AppCustomPropertyErrorProps) => {
    return (
        <>
            {flagRequired &&
                <div className="app-custom-property-error">
                    <MyTooltip title="This field is required">
                        <Asterisk size={16} color="red"/>
                    </MyTooltip>
                </div>
            }
            {flagError && !flagRequired &&
                <div className="app-custom-property-error">
                    <MyTooltip title={errorString || "Error"}>
                        <CircleAlert size={16} color="red"/>
                    </MyTooltip>
                </div>
            }
        </>
    )
}
